// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"styles_alertContainer__9gwVp","icon":"styles_icon__6sfoP","text":"styles_text__qZY4J","title":"styles_title__VfSVi"};